import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ],
    standalone: false
})
export class NavbarComponent implements OnDestroy {

    navbarClass = 'navbar-area';
    menuOpen = false;
    venturesOpen = false;
    servicesActive = false;
    venturesActive = false;

    private routerSubscription: Subscription;

    constructor(private router: Router) {
        this.routerSubscription = this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(event => {
            const path = event.urlAfterRedirects.split(/[?#]/)[0];
            this.navbarClass = path === '/' ? 'navbar-area' : 'navbar-area navbar-style-two';
            this.servicesActive = path === '/services' || path.startsWith('/service-');
            this.venturesActive = path.startsWith('/ventures/');
            this.closeMenus();
        });
    }

    toggleMenu() {
        this.menuOpen = !this.menuOpen;
    }

    // Close the mobile menu after picking a link (covers re-clicking the current page too,
    // which doesn't trigger a NavigationEnd).
    onNavClick(event: MouseEvent) {
        if ((event.target as HTMLElement).closest('a[href]')) {
            this.closeMenus();
        }
    }

    onVenturesFocusOut(event: FocusEvent) {
        const next = event.relatedTarget as Node | null;
        if (!next || !(event.currentTarget as HTMLElement).contains(next)) {
            this.venturesOpen = false;
        }
    }

    private closeMenus() {
        this.menuOpen = false;
        this.venturesOpen = false;
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }

}
